import React, { useRef, useEffect, useState } from 'react';




const EQXYCanvas = ({
    bands,              // { bass:{freq,gain}, treble:{freq,gain} }if (d < minDist && d
    setBands,
    width = 500,
    height = 250,
    minFreq = 20,
    maxFreq = 20000,
    minGain = -12,
    maxGain = 12,
    eq_color
}) => {
    const canvasRef = useRef(null);
    const [dragBand, setDragBand] = useState(null);
  
    // logスケール変換
    const freqToX = (f) => {
        const logMin = Math.log10(minFreq);
        const logMax = Math.log10(maxFreq);
        return (Math.log10(f) - logMin) / (logMax - logMin) * width;
    };

    const xToFreq = (x) => {
        const logMin = Math.log10(minFreq);
        const logMax = Math.log10(maxFreq);
        const v = x / width * (logMax - logMin) + logMin;
        return Math.pow(10, v);
    };

    const gainToY = (g) => {
        return height - ((g - minGain) / (maxGain - minGain)) * height;
    };

    const yToGain = (y) => {
        return ((height - y) / height) * (maxGain - minGain) + minGain;
    };

    const draw = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, width, height);

        // 背景
        ctx.fillStyle = '#0f0f0f';
        ctx.fillRect(0, 0, width, height);

        // グリッド
        ctx.strokeStyle = '#222';
        for (let i = 0; i <= 10; i++) {
            const y = (i / 10) * height;
            ctx.beginPath();
            ctx.moveTo(0, y);
            ctx.lineTo(width, y);
            ctx.stroke();
        }

        // 0dBライン
        const zeroY = gainToY(0);
        ctx.strokeStyle = '#444';
        ctx.beginPath();
        ctx.moveTo(0, zeroY);
        ctx.lineTo(width, zeroY);
        ctx.stroke();

        // バンドポイント描画
        Object.entries(bands).forEach(([key, band]) => {
            const x = freqToX(band.freq);
            const y = gainToY(band.gain);

            ctx.beginPath();
            ctx.arc(x, y, 7, 0, 2 * Math.PI);
            ctx.fillStyle = eq_color[key];
            ctx.fill();

            // ラベル
            ctx.fillStyle = '#fff';
            ctx.font = '11px sans-serif';
            ctx.fillText(
                `${Math.round(band.freq)}Hz / ${band.gain.toFixed(1)}dB`,
                x + 10,
                y - 10
            );
        });
    };

    useEffect(draw, [bands]);

    const getTouchPos = (e) => {
        const rect = canvasRef.current.getBoundingClientRect();
        const t = e.touches[0];
        return { x: t.clientX - rect.left, y: t.clientY - rect.top };
    };

    const getMousePos = (e) => {
        const rect = canvasRef.current.getBoundingClientRect();
        return { x: e.clientX - rect.left, y: e.clientY - rect.top };
    };

    const findNearestBand = (x, y) => {
        let nearest = null;
        let minDist = Infinity;

        Object.entries(bands).forEach(([key, band]) => {
            const bx = freqToX(band.freq);
            const by = gainToY(band.gain);
            const d = Math.hypot(bx - x, by - y);

            if (d < minDist) {
                minDist = d;
                nearest = key;
            }
        });

        return nearest; // ★ 常に一番近い点を掴む
    };


    const updateBand = (x, y) => {
        if (!dragBand) return;
        const cx = Math.max(0, Math.min(width, x));
        const cy = Math.max(0, Math.min(height, y));

        const freq = xToFreq(cx);
        const gain = yToGain(cy);


        setBands(prev => ({
            ...prev,
            [dragBand]: {
                ...prev[dragBand],
                freq: Math.min(maxFreq, Math.max(minFreq, freq)),
                gain: Math.min(maxGain, Math.max(minGain, gain))
            }
        }));
    };

    // Mouse
    const onMouseDown = (e) => {
        const { x, y } = getMousePos(e);
        const b = findNearestBand(x, y);
        if (b) setDragBand(b);
    };

    const onMouseMove = (e) => {
        if (!dragBand) return;
        const { x, y } = getMousePos(e);
        updateBand(x, y);
    };

    const onMouseUp = () => setDragBand(null);

    // Touch
    const onTouchStart = (e) => {
        const { x, y } = getTouchPos(e);
        const b = findNearestBand(x, y);
        if (b) setDragBand(b);
    };

    const onTouchMove = (e) => {
        //e.preventDefault();
        if (!dragBand) return;
        const { x, y } = getTouchPos(e);
        updateBand(x, y);
    };

    const onTouchEnd = () => setDragBand(null);

    return (
        <canvas
            ref={canvasRef}
            width={width}
            height={height}
            onMouseDown={onMouseDown}
            onMouseMove={onMouseMove}
            onMouseUp={onMouseUp}
            onMouseLeave={onMouseUp}
            onTouchStart={onTouchStart}
            onTouchMove={onTouchMove}
            onTouchEnd={onTouchEnd}
            style={{
                width: `${width}px`,   // ← 100%禁止
                height: `${height}px`, // ← 100%禁止
                touchAction: 'none',
                cursor: 'pointer'
            }}
        />
    );
};

export default EQXYCanvas;
